export default class Newsletter {
  constructor(contents) {
    this.newsletter = contents.querySelector("._newsletter");
    this.checkboxContainer = contents.querySelector("._checkboxContainer");
    this.radio = this.newsletter.getElementsByTagName("input");
    if (this.checkboxContainer) {
      this.checkbox = this.checkboxContainer.getElementsByTagName("input");
    }

    this.setup();
  }

  setup() {
    this.radio[0].addEventListener("change", (event) => {
      this.checkboxContainer.classList.remove("off");
    });
    this.radio[1].addEventListener("change", (event) => {
      this.checkboxContainer.classList.add("off");
      if (this.checkbox) {
        for (var i = 0; i < this.checkbox.length; i++) {
          this.checkbox[i].checked = false;
        }
      }
    });
  }
}
